import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip, Tag } from "antd";
const ProblemRideTag = ({ bold }) => (React.createElement(Tooltip, { color: "#fff", title: "A shipment had an out-of-the-ordinary event such as a wreck, stolen vehicle,\n    vehicle mistakenly picked up leading to an unexpected split load, etc." },
    React.createElement(Tag, { color: "warning", style: { fontWeight: bold ? "bold" : "normal" } },
        React.createElement(InfoCircleOutlined, null),
        " Problem Ride")));
ProblemRideTag.defaultProps = {
    bold: false,
};
export default ProblemRideTag;
